export { List, type ListProps } from "./List";
export { Heading, type HeadingProps } from "./Heading";
export { I18NHeading, type I18NHeadingProps } from "./I18NHeading";
export { I18NLink, type I18NLinkProps } from "./I18NLink";
export { I18NParagraph, type I18NParagraphProps } from "./I18NParagraph";
export { Link, type LinkProps } from "./Link";
export { Paragraph, type ParagraphProps } from "./Paragraph";
export { Table, type TableProps } from "./Table";